import { wrapErrorHandler } from "../../utils/wrap_error_handler";
import SuggestionInterface from "./suggestion_interface";
import http from "../../http";

class SuggestionRepository implements SuggestionInterface {
  async suggestion(title: string, description: string): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      return http.post(`api/decola/suggestion`, {
        title: title,
        description: description
      });
    });
  }
}

export default new SuggestionRepository() as SuggestionInterface;
